import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import { EventsService } from 'src/app/services/eventsService';

@Component({
    selector: 'app-orderpopover',
    templateUrl: './orderpopover.component.html',
    styleUrls: ['./orderpopover.component.scss'],
    standalone: false
})
export class OrderpopoverComponent implements OnInit {
  ascdesc = 'asc';
  updown = 'down';
  iconname = 'arrow-' + this.updown + '-outline';
  fields: string[];
  showhelp = true;
  constructor(
    private events: EventsService,
    private popoverController: PopoverController,
    navParams: NavParams
  ) {

      if (navParams.get('fields')) {
        this.fields = navParams.get('fields')
      }

      // console.log('fields', this.fields);
  }
  ngOnInit() {}

  switchUpDown() {
    this.updown = this.updown === 'up' ? 'down' : 'up';
    this.iconname = 'arrow-' + this.updown + '-outline';
    this.ascdesc = this.updown === 'up' ? 'desc' : 'asc';
  }

  order(field: string) {
    this.events.order.next({ field: field, ascdesc: this.ascdesc } );
    this.popoverController.dismiss();
  }

  showHelp() {
    this.showhelp = true;
  }
}
